import styled from 'styled-components';

export const Refresh = styled.div`
  cursor: pointer;
`;
